export default __webpack_public_path__ + "static/media/Blog7.6d18c98e.png";